<template>
<div class="container">
  <div class="nav-box">
    <div class="nav-list">
      <div class="nav-item" data-url="/shop/invoice/apply/" @click="pageNav">
        <div class="nav-icon invoice">
        </div>
        <div class="nav-name">
          发票相关
        </div>
      </div>
      <div class="nav-item" data-url="/parents/logistic/list/" @click="pageNav">
        <div class="nav-icon logistics">
        </div>
        <div class="nav-name">
          物流相关
        </div>
      </div>
      <router-link to="/account/choose-course" class="nav-item">
        <div class="nav-icon master">
        </div>
        <div class="nav-name">
          数学班主任
        </div>
      </router-link>
    </div>
    <div class="nav-line"></div>
    <div class="nav-list">
      <div class="nav-item" @click="introduceUs">
        <div class="nav-icon understand">
        </div>
        <div class="nav-name">
          &ensp;了解VIPKID&ensp;数学思维
        </div>
      </div>
      <router-link to="/account/device" class="nav-item">
        <div class="nav-icon equipment">
        </div>
        <div class="nav-name">
          上课设备要求
        </div>
      </router-link>
      <div class="nav-item"></div>
    </div>
  </div>
</div>
</template>
<script>
import gateway from '@/_gateway.config'
export default {
  data () {
    return {}
  },
  methods: {
    pageNav (e) {
      var url = e.currentTarget.dataset.url
      location.href = `${gateway.masterpage}${url}`
    },
    introduceUs () {
      location.href = 'https://mp.weixin.qq.com/s/ZP90qaxBcYxTcR9AZl3-Mg'
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/img/account/spriteout/sprites.scss";
.container{
  background: #F0F0F0;
  padding-top:41px;
}
.nav-box{
  margin:0 auto;
  padding:45px 32px;
  background:white;
  border-radius: 20px;
  width:680px;
}
.nav-list{
  display:flex;
  justify-content: space-between;
  .nav-item{
    width:150px;
    .nav-icon{
      margin:0 auto;
      &.invoice{
        @include sprite(invoice);
      }
      &.master{
        @include sprite(master);
      }
      &.logistics{
        @include sprite(logistics);
      }
      &.understand{
        @include sprite(understand);
      }
      &.equipment{
        @include sprite(equipment);
      }
    }
    .nav-name{
      margin-top:15px;
      text-align: center;
      font-size: 22px;
      font-weight: bold;
      color: #666666;
      line-height: 30px;
    }
  }
}
.nav-line{
  background:#DEDEDE;
  height:2px;
  margin:42px 0 50px;
}
</style>
